import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { styled } from '@mui/material/styles'

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  fontSize: 14,
  '&>span:hover': {
    textDecoration: 'underline'
  },
  '&>svg': {
    verticalAlign: 'middle',
    marginRight: theme.spacing(1)
  }
}))

const LinkRenderer = (configure, options: any = {}) => {
  return function renderLink(value, item) {
    const { text, to, icon } = configure(value, item)

    return <CellLink style={options.style} to={to} icon={icon} text={text} />
  }
}

export default LinkRenderer

const BaseCellLink = ({ style, to, text, icon }) => (
  <StyledLink style={style} to={to} onClick={event => event.stopPropagation()}>
    {icon && React.cloneElement(icon)}
    <span>{text}</span>
  </StyledLink>
)
BaseCellLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  style: PropTypes.object
}

const CellLink = React.memo(BaseCellLink)
